import { render, staticRenderFns } from "./Ocr.vue?vue&type=template&id=6e6ed580&scoped=true&"
import script from "./Ocr.vue?vue&type=script&lang=ts&"
export * from "./Ocr.vue?vue&type=script&lang=ts&"
import style0 from "./Ocr.vue?vue&type=style&index=0&id=6e6ed580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6ed580",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAlert,VBtn,VSnackbar})
